import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LinkWithArrow from 'components/essentials/LinkWithArrow/LinkWithArrow';
import useRandomId from 'hooks/useRandomId';
const FluidTextBlock = t0 => {
  const $ = _c(15);
  const {
    header,
    text,
    cta
  } = t0;
  const HeaderTag = header.tagName || "div";
  const headerId = useRandomId("FluidTextBlock-Header-");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="[border-top:2px_solid_#107c8c] box-border [content:''] block h-0 mt-[60px] mx-0 mb-5 w-[30px] md:w-10" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== HeaderTag || $[2] !== header || $[3] !== headerId) {
    t2 = header && <HeaderTag className="text-xl font-bold mb-2.5" id={headerId}>{header.content}</HeaderTag>;
    $[1] = HeaderTag;
    $[2] = header;
    $[3] = headerId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== cta || $[6] !== header || $[7] !== headerId) {
    t3 = !!cta && cta.content && <div className="text-base mt-5 font-bold"><LinkWithArrow to={cta.linkTo} aria-labelledby={header ? headerId : undefined}>{cta.content}</LinkWithArrow></div>;
    $[5] = cta;
    $[6] = header;
    $[7] = headerId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3 || $[10] !== text.content) {
    t4 = <div className="font-normal text-base">{text.content}{t3}</div>;
    $[9] = t3;
    $[10] = text.content;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <div className="text-gray">{t1}{t2}{t4}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
FluidTextBlock.propTypes = {
  header: PropTypes.shape({
    content: PropTypes.string,
    tagName: PropTypes.string
  }),
  text: PropTypes.shape({
    content: PropTypes.string
  }),
  cta: PropTypes.shape({
    content: PropTypes.string,
    linkTo: PropTypes.string
  })
};
export default FluidTextBlock;